module.exports = __webpack_public_path__ + "img/auxiliacamp_tech_Normal_ua.095d4fe1.webp";